const COUPON_CALLOUT_COMPONENT_FOR_EU_AND_ANZS = "pot_component_for_locale";

export { COUPON_CALLOUT_COMPONENT_FOR_EU_AND_ANZS };
//# sourceMappingURL=src-constants-featureFlags.js.map
